import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("fr");
  const t = useCallback(
    (key) => {
      const parts = key.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node === undefined) return key;
      }
      return node;
    },
    [lang]
  );
  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
